import React from "react";
import { Box, Button } from "@mui/material";

import StickyHeadTable from "./StickyHeadTable";
import AdminPickAndSelectSiteInterface from "../interfaces/AdminPickAndSelectSiteInterface";
import CustomSnackbar from "./utils/Snakbar";
import CommonDialog from "./utils/Dialogs";
import { isMobile } from "react-device-detect";
import dateFormat from "dateformat";
import PageWrapper from "./layout/PageWrapper";
import RecordsBox from "./RecordsBox";

const AdminItems = (props) => {
  const {
    superUser,
    items,
    merchants,
    onDelete,
    onEdit,
    onEdit2,
    onRefreshData,
    businessType,
  } = props;

  const [itemsForSelection, setItemsForSelection] = React.useState([]);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("test");
  const [success, setSuccess] = React.useState(false);

  const handleItemsForSelectionChange = (items) => {
    setItemsForSelection(items);
  };

  const handleClickAssignItemsToPlatform = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = (result) => {
    const { message, success: isSuccess } = result || {};
    setOpenDialog(false);
    if (message) {
      setSnackbarMessage(message);
      setSuccess(true);
    }
    // Réinitialiser la sélection si succès
    if (isSuccess) {
      setItemsForSelection([]);
    }
  };

  const isCompliant = (item) => {
    const errors = [];
    if (!item?.prices || item?.prices?.length === 0) {
      errors.push("Prix non renseigné.");
    }
    if (!item.files || item.files.length === 0) {
      errors.push("Une image est nécessaire pour l'affichage en boutique.");
    }
    if (!item.platforms || item.platforms.length === 0) {
      errors.push("Une plateforme de promotion de l'article est requise.");
    }
    if (parseInt(item.published, 10) === 0) {
      errors.push("L'article n'est pas encore publié.");
    }
    return errors;
  };

  const formattedItems = items.map((i) => ({
    ...i,
    created: dateFormat(i.created, "mmm dS, H:MM"),
    compliant: isCompliant(i),
    published: i.published === 1 ? "Publié" : "Non publié",
    nb: `${i.busy} / ${i.nb}`,
    description:
      i.description?.length > 60
        ? `${i.description?.substr(1, 60)}...`
        : i.description,
  }));

  const displayedColumns = [
    { id: "id", label: "#", minWidth: 50, align: "left" },
    { id: "compliant", label: "Valide", minWidth: 50, align: "left" },
    { id: "title", label: "Libellé", minWidth: 170 },
    { id: "published", label: "Status", minWidth: 50 },
    { id: "nb", label: "Stock", minWidth: 80 },
    { id: "created", label: "Crée le", minWidth: 60 },
    { id: "platforms", label: "platformes", minWidth: 100, align: "left" },
    { id: "files", label: "Images", minWidth: 120 },
    { id: "action", label: "Actions", minWidth: isMobile ? 90 : 90 },
  ];

  return (
    <PageWrapper>
      <CustomSnackbar
        text={snackbarMessage}
        open={success}
        onCloseSnakbar={() => setSuccess(false)}
      />

      <RecordsBox items={items} itemsForSelection={itemsForSelection} />

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          my: 2,
        }}
      >
        <Button
          disabled={itemsForSelection.length === 0}
          onClick={handleClickAssignItemsToPlatform}
          variant="contained"
        >
          Assigner un site de vente
        </Button>
      </Box>

      <CommonDialog
        title="Sélection des plateformes de promotion"
        onClose={handleDialogClose}
        open={openDialog}
        render={() => (
          <AdminPickAndSelectSiteInterface
            onCancelAction={handleDialogClose}
            callback={handleDialogClose}
            items={itemsForSelection}
            merchants={merchants}
            onPostSave={handleDialogClose}
          />
        )}
      />

      <StickyHeadTable
        businessType={businessType}
        superUser={superUser}
        filters={["id", "title", "published", "platforms"]}
        columns={
          isMobile
            ? displayedColumns.filter(
                (c) => c.id === "title" || c.id === "action"
              )
            : displayedColumns
        }
        data={(formattedItems || []).map((i) => ({
          ...{ id: i.id },
          ...{ title: i.title },
          ...{ platforms: i.platforms || [].map((p) => p.name).join(", ") },
          ...{ published: i.published },
          ...{ recurrent: i.isRecurrent },
          ...{ nb: (i.available || 0).toString() },
          ...{ files: i.files },
          ...{ created: i.created.toString() },
        }))}
        onDelete={onDelete}
        onEdit={onEdit}
        onEdit2={onEdit2}
        onItemsForSelectionChange={handleItemsForSelectionChange}
        onRefreshData={onRefreshData}
        checkboxEnabled={true}
        selectedItems={itemsForSelection}
      />
    </PageWrapper>
  );
};

export default AdminItems;
